import { render, staticRenderFns } from "./closedSpaceEduInfo.vue?vue&type=template&id=52b649ce"
import script from "./closedSpaceEduInfo.vue?vue&type=script&lang=js"
export * from "./closedSpaceEduInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b649ce')) {
      api.createRecord('52b649ce', component.options)
    } else {
      api.reload('52b649ce', component.options)
    }
    module.hot.accept("./closedSpaceEduInfo.vue?vue&type=template&id=52b649ce", function () {
      api.rerender('52b649ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/closedSpaceEduInfo.vue"
export default component.exports